module.exports = __webpack_public_path__ + "img/app-qrcode.d8fcbb38.png";